import {
  ACTION_LOAD_WIRE__REQUEST,
  ACTION_LOAD_WIRE__SUCCESS,
  ACTION_LOAD_WIRE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_WIRE__REQUEST:
    case ACTION_LOAD_WIRE__SUCCESS:
      return null;

    case ACTION_LOAD_WIRE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
